// extracted by mini-css-extract-plugin
export default {"badge":"NotificationBadge_badge__UuPH+","stampIn":"NotificationBadge_stampIn__tTfY5","dot":"NotificationBadge_dot__TAPuI","large":"NotificationBadge_large__oWhnD"};